export const UI_LOAD = 'UI_LOAD'
export const uiLoad = () => ({
  type: UI_LOAD
})

export const UI_LOAD_SUCCESS = 'UI_LOAD_SUCCESS'
export const uiLoadSuccess = (settings: {
  sidebarCollapsed: boolean
}): UILoadSuccessAction => ({
  type: UI_LOAD_SUCCESS,
  ui: settings
})

export const UI_SET_SIDEBAR_COLLAPSED = 'UI_SET_SIDEBAR_COLLAPSED'
export const uiSetSidebarCollapsed = (
  collapsed: boolean
): UISetSidebarCollapsedAction => ({
  type: UI_SET_SIDEBAR_COLLAPSED,
  collapsed
})

export const UI_SET_DELIVERY_TABLE_COLUMNS = 'UI_SET_DELIVERY_TABLE_COLUMNS'
export const uiSetDeliveryTableColumns = (columns: any[]): any => ({
  type: UI_SET_DELIVERY_TABLE_COLUMNS,
  columns
})

export const UI_SET_WASTE_TABLE_COLUMNS = 'UI_SET_WASTE_TABLE_COLUMNS'
export const uiSetWasteTableColumns = (columns: any[]): any => ({
  type: UI_SET_WASTE_TABLE_COLUMNS,
  columns
})

export const UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS =
  'UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS'
export const uiSetOrderedDeliveryTableColumns = (columns: string[]): any => ({
  type: UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS,
  columns
})

export const UI_SET_ORDERED_WASTE_TABLE_COLUMNS =
  'UI_SET_ORDERED_WASTE_TABLE_COLUMNS'
export const uiSetOrderedWasteTableColumns = (columns: string[]): any => ({
  type: UI_SET_ORDERED_WASTE_TABLE_COLUMNS,
  columns
})

export const UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS =
  'UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS'
export const uiSetShownDeliveryTableColumns = (columns: string[]): any => ({
  type: UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS,
  columns
})

export const UI_SET_SHOWN_WASTE_TABLE_COLUMNS =
  'UI_SET_SHOWN_WASTE_TABLE_COLUMNS'
export const uiSetShownWasteTableColumns = (columns: string[]): any => ({
  type: UI_SET_SHOWN_WASTE_TABLE_COLUMNS,
  columns
})

// INTERFACEs
export interface UILoadAction {
  type: typeof UI_LOAD
}

interface UILoadSuccessAction {
  type: typeof UI_LOAD_SUCCESS
  ui: { sidebarCollapsed: boolean }
}

export interface UISetSidebarCollapsedAction {
  type: typeof UI_SET_SIDEBAR_COLLAPSED
  collapsed: boolean
}

export interface UISetDeliveryTableColumnsAction {
  type: typeof UI_SET_DELIVERY_TABLE_COLUMNS
  columns: any[]
}

export interface UISetWasteTableColumnsAction {
  type: typeof UI_SET_WASTE_TABLE_COLUMNS
  columns: any[]
}

export interface UISetOrderedDeliveryTableColumnsAction {
  type: typeof UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS
  columns: string[]
}

export interface UISetOrderedWasteTableColumnsAction {
  type: typeof UI_SET_ORDERED_WASTE_TABLE_COLUMNS
  columns: string[]
}

export interface UISetShownDeliveryTableColumnsAction {
  type: typeof UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS
  columns: string[]
}

export interface UISetShownWasteTableColumnsAction {
  type: typeof UI_SET_SHOWN_WASTE_TABLE_COLUMNS
  columns: string[]
}
